import { selectMultipleOptions } from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Actions';
import { OptionClassificationIdentifiers } from '../Enums';
import { getOptionClassification } from './optionClassifications';
import { resolveItemColorOptionIds } from './colorOptionResolve';
import type { EditorItem } from '../Reducers/Configurator/types';

export function collectDesignColorOptionIds(
  items: EditorItem[],
  colorOptions: unknown[] = []
): Set<string> {
  const used = new Set<string>();

  items.forEach((item) => {
    resolveItemColorOptionIds(item, colorOptions).forEach((colorId) => used.add(colorId));
  });

  return used;
}

/** Build a minimal multiselect payload — only entries that differ from current config. */
export function buildColorSyncPayload(
  usedIdentifiers: Set<string>,
  currentlySelected: Array<{ identifier?: string; amount?: number }> = []
): Array<{ identifier: string; amount: number }> {
  const payload: Array<{ identifier: string; amount: number }> = [];
  const selectedAmountById = new Map<string, number>();

  currentlySelected.forEach((option) => {
    if (!option.identifier) return;
    selectedAmountById.set(option.identifier, option.amount ?? 0);
  });

  usedIdentifiers.forEach((identifier) => {
    if (selectedAmountById.get(identifier) === 1) return;
    payload.push({ identifier, amount: 1 });
  });

  currentlySelected.forEach((option) => {
    const identifier = option.identifier;
    if (!identifier || usedIdentifiers.has(identifier)) return;
    if ((option.amount ?? 0) <= 0) return;
    payload.push({ identifier, amount: 0 });
  });

  return payload;
}

export function syncDesignColorOptions(
  dispatch: (action: unknown) => void,
  getState: () => Record<string, unknown>
): void {
  const state = getState();
  const configurator = state.configurator as {
    configuration?: { customdata?: { editor?: { objects?: Record<string, EditorItem> } }; optionclassifications?: unknown };
    optionsList?: Record<string, unknown[]>;
  };
  const editor = configurator?.configuration?.customdata?.editor;
  const items: EditorItem[] = editor?.objects ? Object.values(editor.objects) : [];
  const options: unknown[] = configurator?.optionsList?.[OptionClassificationIdentifiers.color] || [];
  const usedIdentifiers = collectDesignColorOptionIds(items, options);

  const colorClassification = getOptionClassification(
    configurator?.configuration?.optionclassifications,
    OptionClassificationIdentifiers.color
  );
  const selectedoptions = buildColorSyncPayload(
    usedIdentifiers,
    colorClassification?.selectedoptions ?? []
  );

  if (selectedoptions.length === 0) return;

  dispatch(
    selectMultipleOptions([
      {
        identifier: OptionClassificationIdentifiers.color,
        selectedoptions,
      },
    ])
  );
}
